import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { envs } from '../data/env.data';
import { AuthRequest, AuthResponse } from '../model/auth-types';
import { Banner } from '../data/banner.data';

@Injectable({
  providedIn: 'root',
})
export class AuthenticateService {
  private readonly http = inject(HttpClient);
  private accessToken = '';
  setToken$ = new Subject<boolean>();

  setApiAuthToken(banner: Banner, ppc?: string) {
    const url = `${envs.apiBaseTokenUrl}/${banner}/login`;

    const body: AuthRequest = {};
    if (ppc) body.ppc = ppc;
    this.http.post<AuthResponse>(url, body).subscribe({
      next: (data) => {
        this.accessToken = 'Bearer ' + data.access_token;
        this.setToken$.next(true);
      },
    });
  }

  getApiAuthToken(): string {
    return this.accessToken;
  }
}
